import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function PaymentSuccess() {
  const navigate = useNavigate();
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get("orderNo");
    setOrderId(id);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f7fa",
        padding: 20,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px 30px",
          borderRadius: "16px",
          textAlign: "center",
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
          animation: "fadeIn 0.5s ease-out",
        }}
      >
        {/* Success Icon */}
        <img
          src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
          alt="success"
          style={{ width: 90, marginBottom: 20 }}
        />

        <h2 style={{ color: "#16a34a", marginBottom: 8, fontWeight: 700 }}>
          Order Placed Successfully!
        </h2>

        <p style={{ color: "#555", marginBottom: 20, fontSize: 15 }}>
          Thank you for shopping with us.  
          Your order has been confirmed and is being processed.
        </p>

        {/* Order ID Box */}
        {orderId && (
          <div
            style={{
              background: "#f1f5f9",
              padding: 15,
              borderRadius: 10,
              marginBottom: 20,
              fontSize: 15,
              border: "1px solid #e2e8f0",
            }}
          >
            <strong>Order ID:</strong> {orderId}
          </div>
        )}

        {/* Continue Button */}
        <button
          onClick={() => navigate("/")}
          style={{
            background: "#0ea5a4",
            color: "#fff",
            padding: "12px 20px",
            border: "none",
            borderRadius: 10,
            fontSize: 16,
            cursor: "pointer",
            width: "100%",
            fontWeight: 600,
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.background = "#0c8e8d")}
          onMouseOut={(e) => (e.target.style.background = "#0ea5a4")}
        >
          Continue Shopping
        </button>
      </div>

      {/* Animation Keyframe */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}

export default PaymentSuccess;
